export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const cleanUpSlug = (slug) => {
  var find = ['project/', 'journal-article/']
  var replace = ['projects/', 'journal/']

  return find.reduce((acc, item, i) => {
    const regex = new RegExp(item, 'g')
    return acc.replace(regex, replace[i])
  }, slug)

  // let res = slug.split('/')
  // return res[res.length - 1].length ? res[res.length - 1] : res[res.length - 2]
}

const API_URL = process.env.REACT_APP_API_PATH
const REST_BASE = process.env.REACT_APP_REST_BASE

export const endpoints = {
  'page': `${API_URL}${REST_BASE}/pages`,
  'projects': `${API_URL}${REST_BASE}/project`,
  'journal': `${API_URL}${REST_BASE}/journal_article`,
  'job-opening': `${API_URL}${REST_BASE}/job_opening`
}

/**
 *
 * @param route
 * @returns {string}
 */
export const getApiEndpoint = (route) => {
  const singles = ['journal', 'projects']
  singles.forEach(function (value) {
    singles.push(value + '/')
  })


  if (singles.indexOf(route) > -1) {
    const ep = endpoints[route.replace(/\/$/, '')] + '?per_page=100'
    return ep
  }

  if (route.startsWith('journal/') || route.startsWith('projects/') || route.startsWith('job-opening/')) {
    const split = route.split('/')
    const page = split[0]
    // const item = split[1]
    const item = split.slice(1, split.length).join('/')

    // const [page, item] = route.split('/')

    return item.length ? endpoints[page] + '?slug=' + item : endpoints[page]
  }

  return endpoints.page + '?slug=' + route
}

/**
 *
 * @param data
 * @param slug
 * @returns {{slider: {slides: *, hero: *}, favicon: (boolean|*), footer: *, grid: ({showProjectsLink: boolean, blocks: *, key: string}|{filterKey: string, blocks: *, key: string}), headerTheme: string, metaTags: *, header, menus: *, content: {text: string, type: string, title: *}[]}|boolean}
 */
export const parseApiData = (data, slug) => {
  if (!data) {
    return false
  }

  // @todo figure out better archive detection
  const isArchive = !!data.posts

  const single = isArchive ? false : data[0]
  let headerTheme = ''
  let header = {}
  let grid
  let slider
  let content

  if (isArchive) {
    content = getPageComponents(data.posts, isArchive)
  } else {
    content = getPageComponents(data, isArchive)
  }

  if (single && single.fields.blocks_group) {
    grid = {
      key: 'home-grid',
      showProjectsLink: true,
      blocks: single.fields.blocks_group.value[0].blocks.value.map(block => {
        if (block.type.value === 'project') {
          const slug = cleanUpSlug(block.project.value[0].slug.value)
          const project = block.project.value[0]
          return {
            url: `${slug}`,
            type: 'project',
            label: block.project.meta.label,
            title: project.client.value,
            subtitle: project.listing_subtitle.value,
            tags: project.categories && project.categories.value.project_category.map(cat => cat.name).join(', '),
            img: project.hero_image.value.original[0]
          }
        } else {
          const content = block.content.value[0]
          return {
            type: 'hiring',
            label: content.category.value,
            title: content.title.value,
            subtitle: content.subtitle.value,
            description: content.body.value,
            cta_text: content.cta_text.value,
            cta_link: content.cta_link.value
          }
        }
      })
    }
  }

  if (single) {
    headerTheme = single.fields.group_page_settings ? single.fields.group_page_settings.value[0].menu_theme.value : ''

    header = {
      ...header,
      title: single.title,
      subtitle: single.fields.group_page_settings ? single.fields.group_page_settings.value[0].subtitle.value : false
    }

    slider = {
      slides: single.fields.slider_group && single.fields.slider_group.value[0].slider,
      hero: single.fields.group_page_settings && single.fields.group_page_settings.value[0].hero_image.value
    }

    if (slug.startsWith('job-opening/')) {
      header = {
        ...header,
        href: '/contact',
        backTo: 'Careers',
        subtitle: single.fields.subtitle.value
      }

      const contactLink = `<p class="hoverable-link"><a href="mailto:info@artandmechanical.com?subject=${single.title}">Apply now—</a></p>`

      content = [{
        type: 'text',
        title: single.fields.description.meta.label,
        text: single.fields.description.value + contactLink
      }]
    }

    if (slug.startsWith('journal/')) {
      header = {
        ...header,
        href: '/journal',
        backTo: 'Journal',
        subtitle: `${single.date.date_formatted} | ${single.author.nickname}`,
        image: single.fields.journal.value[0].hero_image.value.original[0]
      }

      // Append Navigation to the content
      content.push({
        type: 'nav',
        next: {
          label: single.nav.prev.label,
          href: cleanUpSlug(single.nav.prev.href)
        },
        prev: {
          label: single.nav.next.label,
          href: cleanUpSlug(single.nav.next.href)
        }
      })
    }

    if (slug.startsWith('projects/')) {
      header = {
        ...header,
        href: '/projects',
        backTo: 'Projects',
        subtitle: single.fields.main_subtitle.value,
        image: single.fields.hero_image.value.original[0]
      }

      const columns = single.fields.row.value && single.fields.row.value.map(row => {
        if (!row.columns.value) {
          return false
        }

        return {
          type: 'columns',
          columns: row.columns.value.map(column => {
            const type = column.style.value
            const block = column[type].value
            switch (type) {
              case 'quote':
                return {
                  type: type,
                  title: block[0].text.value,
                  name: block[0].name.value,
                  position: block[0].position.value
                }
              case 'image':
                return {
                  type: type,
                  src: block.original[0]
                }
              default: // type: text
                return {
                  type: 'wysiwyg',
                  content: block
                }
            }
          })
        }
      })

      content = [
        {
          type: 'text',
          client: single.fields.client.value || '',
          tags: single.categories && single.categories.project_category.map(cat => cat.name),
          text: single.fields.main_description.value || ''
        },
        ...columns || false,
        {
          type: 'nav',
          next: {
            label: single.nav.prev.label,
            href: cleanUpSlug(single.nav.prev.href)
          },
          prev: {
            label: single.nav.next.label,
            href: cleanUpSlug(single.nav.next.href)
          }
        }
      ]
    }
  }

  if (slug === 'insights-lead-design-for-brands-of-the-future') {
    header = {
      title: false
    }
  }

  let meta

  if (isArchive) {
    meta = data

    switch (slug) {
      case 'journal':
      case 'journal/':
        header = {
          ...header,
          title: data.meta.title,
          subtitle: data.meta.subtitle
        }
        break

      case 'projects/':
      case 'projects':
        header = {
          ...header,
          title: 'Projects'
        }

        grid = {
          key: 'projects-grid',
          filterKey: 'categories',
          blocks: data.posts.map(page => {
            return {
              type: 'project',
              url: `/projects/${page.slug}`,
              label: 'Project',
              title: page.title,
              subtitle: page.fields.listing_subtitle.value,
              categories: page.categories && page.categories.project_category.map(cat => {
                return {
                  id: cat.term_id,
                  name: cat.name,
                  count: cat.count
                }
              }),
              tags: page.categories && page.categories.project_category.map(cat => cat.name).join(', '),
              img: page.fields.hero_image.value.original[0]
            }
          })
        }
        break

      default:
        break
    }
  } else {
    meta = data[0]
  }

  const menus = meta.menus
  const footer = meta.footer
  const favicon = meta.favicon
  const metaTags = meta.yoast_meta

  return {
    favicon,
    menus,
    headerTheme,
    header,
    slider,
    grid,
    content,
    footer,
    metaTags
  }
}

const getPageComponents = (pages, isArchive) => {
  const components = []

  pages.forEach(page => {
    Object.keys(page.fields).forEach(key => {
      const component = page.fields[key]
      let sanitized = {}

      switch (key) {
        case 'wysiwyg':
          components.push({
            type: 'text',
            title: component.value[0].label.value,
            text: component.value[0].wysiwyg.value
          })
          break
        case 'journal':
          if (isArchive) { // only shows on archive page
            const image = !component.value[0].hero_image.value.original ? false : component.value[0].hero_image.value.original[0]

            components.push({
              type: 'journal-excerpt',
              title: page.title,
              time: `${page.date.date_formatted} | ${page.author.nickname}`,
              text: page.excerpt ? page.excerpt.rendered : false,
              href: `/journal/${page.slug}`,
              image: image
            })
          } else { // get all journal data if on single page
            const gallery = !component.value[0].gallery.value ? false : [{
              type: 'gallery',
              useMobileCarousel: true,
              images: component.value[0].gallery.value.map((image) => {
                return {
                  src: image.original[0],
                  full_width: true
                }
              })
            }]

            const text = component.value[0].row.value.map((block) => {
              if (block.style.value === 'quote') {
                return {
                  type: 'quote',
                  title: block.quote.value[0].text.value,
                  name: block.quote.value[0].name.value,
                  position: block.quote.value[0].position.value
                }
              } else {
                return {
                  type: 'wysiwyg',
                  content: block.text.value
                }
              }
            })
            components.push({
              type: 'columns',
              columns: [gallery, text]
            })
          }
          break

        case 'team':
          sanitized = {
            type: 'columns',
            columns: []
          }

          component.value[0].block.value.forEach(block => {
            if (block.type.value === 'team_member') {
              const member = block.team_member.value[0]

              sanitized.columns.push({
                type: 'employee',
                image: member.profile_image.value.large[0],
                name: member.name.value,
                position: member.position.value,
                description: member.bio.value,
                social: member.social_icons.value || false
              })
            }

            if (block.type.value === 'quote') {
              sanitized.columns.push({
                type: 'quote',
                title: block.quote.value[0].text.value,
                name: block.quote.value[0].name.value,
                position: block.quote.value[0].position.value
              })
            }
          })

          // Hardcode the new employee block
          sanitized.columns.push({
            type: 'new-employee'
          })

          components.push(sanitized)
          break

        case 'who_we_are':
        case 'what_we_do':
        case 'how_we_do_it':
        case 'us_and_you':
          components.push({
            type: 'text',
            title: component.value[0].title.value,
            text: component.value[0].text.value
          })
          break

        case 'capabilities':
        case 'client_list':
          components.push({
            type: 'text',
            title: component.meta.label,
            text: component.value[0].category.value.map(column => {
              return {
                title: column.title.value,
                items: column.items.value.map(client => client.item.value)
              }
            })
          })
          break

        case 'group_awards':
          components.push({
            type: 'text',
            title: component.value[0].title.value,
            text: component.value.map(column => {
              return {
                items: column.awards.value.map(item => item.award.value)
              }
            })
          })
          break

        case 'gallery':
          if (component.value) {
            components.push({
              type: 'gallery',
              images: component.value[0].image.value.map(image => {
                return {
                  src: image.image.value.original[0],
                  full_width: image.type.value && image.type.value[0] === 'full_width'
                }
              })
            })
          }
          break

        case 'enquiries':
          const general = component.value[0].general.value[0]
          const newBusiness = component.value[0].new_business.value[0]

          components.push({
            type: 'text',
            title: component.value[0].title.value,
            text: {
              type: 'sections',
              content: [
                {
                  title: general.title.value,
                  content: [
                    general.column_one_text.value,
                    general.column_two_text.value
                  ],
                  cta: {
                    url: general.cta_url.value,
                    target: '_blank',
                    text: general.cta_text.value
                  }
                },
                {
                  title: newBusiness.title.value,
                  content: newBusiness.text.value,
                  cta: {
                    mailto: newBusiness.cta_mailto.value + '?subject=New Business Opportunity',
                    text: newBusiness.cta_text.value
                  }
                }
              ]
            }
          })
          break

        case 'careers':
          const applications = component.value[0].general_applications.value[0]

          let intro = {
            title: applications.title.value,
            content: applications.text.value,
            cta: {
              mailto: applications.cta_mailto.value,
              text: applications.cta_text.value
            }
          }

          let jobs = component.value[0].job_opening.value.map(job => {
            return {
              title: job.name.value,
              fullWidth: true,
              content: job.excerpt.value,
              cta: {
                url: job.slug.value,
                text: 'Read more about this position and apply'
              }
            }
          })

          components.push({
            type: 'text',
            title: component.value[0].title.value,
            text: {
              type: 'sections',
              content: [
                intro,
                {
                  title: 'Current Openings',
                  content: jobs
                }
              ]
            }
          })
          break

        default:
          // console.log('not processing', key, 'object data yet')
          break
      }
    })
  })

  return [].concat.apply([], components)
}



// WEBPACK FOOTER //
// ./src/utils/index.js